import styled from 'styled-components';

const DrawerList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
`;

export default DrawerList;
